import { Component, signal } from '@angular/core';
import { GeneralIconButtonComponent } from '../../components';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { MatIconModule } from '@angular/material/icon';
import { TooltipPosition } from '../../../../core/directives/tooltip';
import { TranslateModule } from '@ngx-translate/core';

export interface CustomButtonParams extends ICellRendererParams {
  onClick: (params: { event: Event; rowData: unknown }) => void;
  icon: string;
  tooltip: string;
  position: TooltipPosition;
}

@Component({
  selector: 'app-ag-grid-icon-button',
  imports: [MatIconModule, TranslateModule, GeneralIconButtonComponent],
  templateUrl: './ag-grid-icon-button.component.html',
})
export class AgGridIconButtonComponent implements ICellRendererAngularComp {
  params!: CustomButtonParams;
  value = signal<boolean | undefined>(undefined);
  agInit(params: CustomButtonParams): void {
    this.params = params;
    this.refresh(params);
  }

  onClick(event: Event) {
    const params = {
      event: event,
      rowData: this.params.node.data,
    };

    this.params.onClick(params);
  }

  refresh(params: CustomButtonParams) {
    this.value.set(params.value);
    return true;
  }
}
